import { render } from "./NavTop.vue?vue&type=template&id=b8874c44&scoped=true"
import script from "./NavTop.vue?vue&type=script&lang=js"
export * from "./NavTop.vue?vue&type=script&lang=js"

import "./NavTop.vue?vue&type=style&index=0&id=b8874c44&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8874c44"]])

export default __exports__